import { render, staticRenderFns } from "./VenueTasks.vue?vue&type=template&id=2829cb9d&scoped=true&"
import script from "./VenueTasks.vue?vue&type=script&lang=js&"
export * from "./VenueTasks.vue?vue&type=script&lang=js&"
import style0 from "./VenueTasks.vue?vue&type=style&index=0&id=2829cb9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2829cb9d",
  null
  
)

export default component.exports